import React, { useCallback, useEffect, useState } from "react";
import style from "css/landing.module.css";
import NoticeListItem from "./noticeListItem";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { color } from "framer-motion";

/**
 * 파일명: NoticeArea.js
 * 작성자: 강연승
 * 작성일자: 24.02.15
 * 설명: landing page - NoticeArea
 */

function NoticeArea() {
  const [run, setrun] = useState(true);
  const [noticeList, setnoticeList] = useState([]);
  const getlist = useCallback(() => {
    let config = {
      params: {
        TYPE: "CD0402",
        ROW_COUNT: 3,
        PAGE_COUNT: 0,
        HOLD: "1",
      },
    };

    axios.get("/open/boardlist", config).then((res) => {
      if (res.status === 200) {
        setnoticeList(res.data);
        setrun(false);
      }
    });
  }, []);

  useEffect(() => {
    if (run) {
      getlist();
    }
  }, [getlist, run]);
  const navigate = useNavigate();
  return (
    <div className={style.wrapper}>
      {/* <div
        className={style.background}
        style={{
          backgroundColor: "#eff5fa",
        }}
      >
      </div> */}

      <div className={style.notice_area}>
        <div className={style.notice_area_label}>
          <div className={style.notice_area_title_wrap}>
            <div className={style.notice_area_title}>공지사항</div>
            <div className={style.notice_area_subtitle}>
              SOFT DOCTOR
              <p style={{ height: "5px" }} />
              <font style={{ color: "#4787ff" }}>새 소식을 </font> 전해드립니다.
            </div>
          </div>
          <div className={style.notice_nav}>
            <div
              className={`${style.notice_viewmore_btn} cursor`}
              onClick={() =>
                navigate(process.env.REACT_APP_CLIENT_URL + "announcement")
              }
            >
              View more
            </div>
          </div>
        </div>

        <div className={style.notice_list}>
          {noticeList.map((notice, index) => (
            <NoticeListItem key={index} notice={notice} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default NoticeArea;
